export default function AdvantagesSection() {
  const advantages = [
    {
      icon: 'ri-rocket-2-line',
      title: 'Livraison en 7 jours max',
      desc: 'Délai moyen de 48h. Votre site en ligne rapidement, sans attente interminable.',
      highlight: '48h en moyenne',
    },
    {
      icon: 'ri-smartphone-line',
      title: 'Optimisé Google & Mobile',
      desc: 'Performance, référencement et affichage parfait sur tous les écrans, smartphone inclus.',
      highlight: 'SEO optimisé',
    },
    {
      icon: 'ri-calendar-check-line',
      title: 'Réservation & Devis intégrés',
      desc: 'Captez vos clients automatiquement 24h/24, sans décrocher le téléphone.',
      highlight: '24h/24 automatique',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Support humain réactif',
      desc: 'Un interlocuteur dédié, pas un chatbot. Réponse garantie sous 4h en semaine.',
      highlight: 'Réponse sous 4h',
    },
    {
      icon: 'ri-palette-line',
      title: 'Design 100% sur mesure',
      desc: 'Aucun template générique. Votre identité visuelle unique, conçue pour vous démarquer.',
      highlight: 'Aucun copier-coller',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Maintenance & sécurité incluses',
      desc: 'Mises à jour, sauvegardes et hébergement sécurisé compris dans votre abonnement mensuel.',
      highlight: 'Zéro souci technique',
    },
  ];

  return (
    <section className="py-16 sm:py-24 px-4 sm:px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12 sm:mb-16">
          <p className="text-xs font-bold text-emerald-500 uppercase tracking-[4px] mb-3">Pourquoi nous choisir</p>
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-black text-slate-900 mb-4">
            Ce Qui Fait la Différence
            <br />
            <span className="bg-gradient-to-r from-emerald-500 to-teal-500 bg-clip-text text-transparent">avec UzunDigital</span>
          </h2>
          <p className="text-sm sm:text-lg text-slate-500 max-w-2xl mx-auto">
            Des résultats concrets, une vraie relation humaine, et un site qui travaille pour vous
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6">
          {advantages.map((item, i) => (
            <div
              key={i}
              className="group relative bg-white rounded-2xl p-6 sm:p-7 border border-slate-100 hover:border-emerald-200 hover:-translate-y-1.5 transition-all duration-300 overflow-hidden"
            >
              {/* Gradient déco BG */}
              <div className="absolute inset-0 bg-gradient-to-br from-emerald-50/0 to-teal-50/0 group-hover:from-emerald-50/60 group-hover:to-teal-50/30 transition-all duration-300 rounded-2xl pointer-events-none"></div>

              <div className="relative">
                <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-xl bg-gradient-to-br from-emerald-500 to-teal-500 flex items-center justify-center mb-5 group-hover:scale-110 transition-transform duration-300">
                  <i className={`${item.icon} text-xl sm:text-2xl text-white`}></i>
                </div>

                <h3 className="text-base sm:text-lg font-bold text-slate-900 mb-2 leading-tight">{item.title}</h3>
                <p className="text-sm text-slate-500 leading-relaxed mb-4">{item.desc}</p>

                <div className="inline-flex items-center gap-1.5 bg-emerald-50 text-emerald-700 text-xs font-bold px-3 py-1.5 rounded-full border border-emerald-100">
                  <i className="ri-check-line text-sm text-emerald-500"></i>
                  {item.highlight}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
